import React, { useState } from 'react';
import { ModalHeader, Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import FormTextArea from '../ReactHookFormCustom/FormTextArea';
import { useForm } from 'react-hook-form';
import { sendVerificationRequest } from '../../Services/companyService';
import useCompanyStore from '../../../../stores/companyStore';

const CompanyVerificationRequestModal = ({ isCompanyVerificationModalOpen, toggleIsCompanyVerificationModalOpen }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const company = useCompanyStore((state) => state.company);
  const fetchCompany = useCompanyStore((state) => state.fetchCompany);

  const handleValidSubmit = (data) => {
    setIsLoading(true);
    sendVerificationRequest(data.companyDescriptionTextArea, company)
      .then((result) => {
        fetchCompany();
      })
      .finally(() => {
        setIsLoading(false);
        reset();
        toggleIsCompanyVerificationModalOpen();
      });
  };

  const { control, handleSubmit, reset } = useForm({});

  const toggleModalLocal = () => {
    reset();
    toggleIsCompanyVerificationModalOpen();
  };

  return (
    <Modal isOpen={isCompanyVerificationModalOpen} centered>
      <ModalHeader>
        <h3 className="d-flex align-items-center">
          <i className="fa fas icon-check mr-2"></i>
          {t('dashboard.VERIFY_COMPANY')}
        </h3>
      </ModalHeader>
      <form onSubmit={handleSubmit(handleValidSubmit)}>
        <ModalBody>
          <FormTextArea
            className
            control={control}
            label={t('dashboard.COMPANY_DESCRIPTION')}
            name="companyDescriptionTextArea"
            id="companyDescriptionTextAreaId"
            maxLength={3000}
            rules={{ required: t('common.REQUIRED') }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={isLoading}>
            {isLoading && <div className="spinner-border spinner-border-sm" role="status" />}
            &nbsp;{t('dashboard.REQUEST_VERIFICATION')}
          </Button>
          <Button color="secondary" onClick={() => toggleModalLocal()}>
            {t('common.CANCEL')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default CompanyVerificationRequestModal;
